import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { featuredResources, getCategoryName } from '@/mocks/resources';

export default function HeroCarousel() {
  const slides = featuredResources.filter((item) => item.banner);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return;
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [slides.length]);

  if (slides.length === 0) return null;

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + slides.length) % slides.length);
  };

  return (
    <section className="relative w-full">
      <div className="relative h-[440px] w-full overflow-hidden md:h-[560px]">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? 'opacity-100' : 'pointer-events-none opacity-0'
            }`}
          >
            <img
              src={slide.banner}
              alt={`${slide.title} 焦点推荐背景`}
              title={`${slide.title} 国语影音推荐`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20" />
          </div>
        ))}

        <div className="relative z-10 mx-auto flex h-full w-full items-center px-4 md:px-8">
          <div className="max-w-2xl text-background-50">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold font-label text-foreground-950">
              <i className="ri-fire-fill" />
              本周焦点推荐
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold leading-tight md:text-5xl">
              {slides[index].title}
            </h2>
            <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-sm text-background-100/90">
              <span className="rounded-md bg-background-50/15 px-2 py-0.5 backdrop-blur">
                {getCategoryName(slides[index].category)}
              </span>
              <span>{slides[index].year}</span>
              <span>·</span>
              <span>{slides[index].region}</span>
              <span>·</span>
              <span>{slides[index].genres.join(' / ')}</span>
              <span className="inline-flex items-center gap-1 text-accent-400">
                <i className="ri-star-fill text-xs" />
                {slides[index].rating.toFixed(1)}
              </span>
            </div>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
              {slides[index].synopsis}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${slides[index].id}`}
                className="inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 text-sm font-semibold font-label text-foreground-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-play-fill text-lg" />
                查看详情
              </Link>
              <Link
                to={`/category/${slides[index].category}`}
                className="inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 text-sm font-label text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览同类资源
              </Link>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={() => go(-1)}
          className="absolute left-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-foreground-950/35 text-background-50 backdrop-blur transition-colors hover:bg-foreground-950/60 md:left-6 md:h-11 md:w-11"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-2xl" />
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          className="absolute right-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-foreground-950/35 text-background-50 backdrop-blur transition-colors hover:bg-foreground-950/60 md:right-6 md:h-11 md:w-11"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-2xl" />
        </button>

        <div className="absolute bottom-5 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? 'w-7 bg-accent-500' : 'w-3 bg-background-50/50'
              }`}
              aria-label={`切换到第${i + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}